import { isExperimentEnabled, getExperimentCohort } from '@atlassian/generative-ai-modal/utils/experiments';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
// Note -- when updating this function -- also update
// the one used in packages/editor/editor-plugin-ai/examples/utils/getDevFetchCustomHeaders.ts
export function _getFetchCustomHeaders() {
  const currentHost = window.location.origin;
  switch (true) {
    case currentHost === 'https://statlas.prod.atl-paas.net':
      // Update this to add custom headers when run in atlaskit branch deploys
      // ie.
      // {
      //   'X-CloudID': 'Magic string'
      // }
      return {};
    default:
      return {};
  }
}
export function deriveHost() {
  const currentHost = typeof window.location !== 'undefined' ? window.location.origin : '';
  if (['http://localhost', 'https://atlaskit-website-staging.stg-east.frontend.public.atl-paas.net', 'https://statlas.prod.atl-paas.net', 'https://atlaskit.atlassian.com'].some(host => currentHost.startsWith(host))) {
    return 'https://pug.jira-dev.com';
  }
  return currentHost;
}
export function deriveGenerativeAIApiUrl() {
  return `${deriveHost()}/gateway/api/editor-ai/v1/generative/ai`;
}
export function deriveProactiveAIApiUrl() {
  if (getBooleanFF('platform.editor.ai-proactive-ai-api-url_k6yy7')) {
    /**
     * Tech Spec for the final endpoint documented at
     * https://hello.atlassian.net/wiki/spaces/CA3/pages/3611700626/BE+Techspec+API+spec+Spelling+and+Grammar#API-spec
     */
    return `${deriveHost()}/gateway/api/v1/grammar`;
  } else {
    /**
     * Currently we are using the MVP endpoint
     * Spec is documented at https://hello.atlassian.net/wiki/spaces/CA3/pages/3716942544/Tech+Spec+POC+Sagemaker+Endpoint+for+Spelling+Grammar
     */
    return `${deriveHost()}/gateway/api/experimental/cc-smarts/sagemaker`;
  }
}
const DEFAULT_CURRENT_CHUNKS_DEBOUNCED_TIME = 4000;
const DEFAULT_CURRENT_CHUNKS_DEBOUNCED_WAIT_TIME = 30000;
const DEFAULT_NON_CURRENT_CHUNKS_THROTTLED_TIME = 2000;
export function deriveProactiveAIConfig(overrides) {
  return {
    enabled: false,
    apiUrl: deriveProactiveAIApiUrl(),
    timings: {
      currentChunks: DEFAULT_CURRENT_CHUNKS_DEBOUNCED_TIME,
      currentChunksMaxWait: DEFAULT_CURRENT_CHUNKS_DEBOUNCED_WAIT_TIME,
      nonCurrentChunks: DEFAULT_NON_CURRENT_CHUNKS_THROTTLED_TIME
    },
    ...overrides
  };
}
export const convoAIStatelessApiURL = `${deriveHost()}/gateway/api/assist/chat/v1/invoke_agent/stream`;
export const convoAIStatefulApiURL = `${deriveHost()}/gateway/api/assist/chat/v1/channel`; // + `/${channelID}/message/stream` at the end;

export function isDefined(value) {
  return value !== undefined;
}
export function getBackendModelExperiment() {
  const isGPT4Enabled = isExperimentEnabled('editor_ai_-_gpt4_experiment');
  const isEinsteinCohort = getExperimentCohort('editor_ai_-_gpt4_experiment') === 'einstein';
  if (isGPT4Enabled && isEinsteinCohort) {
    return 'einstein';
  }
  return 'xp-gen-ai';
}